// ABOUTME: Typed client wrapper for issuing scope-limited service account tokens (super_admin only).
import axios from 'axios';

const API_URL = '/v2/api/admin/service-accounts';

export interface IssuedToken {
  id: string;
  scope: string;
  token: string;
  expiresIn: string;
  revoke: string;
}

export const serviceAccountsApi = {
  /**
   * Creates or re-enables the account and returns a token for it. The token is
   * only ever in the response — it is not stored anywhere readable, so a lost
   * one is reissued rather than looked up.
   */
  issueToken: async (id: string): Promise<IssuedToken> => {
    const response = await axios.post(`${API_URL}/${id}/tokens`, {});
    return response.data;
  },
};
